module.exports = "<p>\r\n  statcommandlivre works!\r\n</p>\r\n"